import { format } from "date-fns";

import api from "services/api";
import { routers_constants } from "services/constants";

const recordStatus = {
  Agendado: 10,
  Iniciando: 11,
  Em_andamento: 12,
  Finalizado: 13,
  Erro: 14,
  Cancelado: 15,
  Processando: 16,
  Downloading: 17,
  Uploading: 18,
  Process_test: -50,
};

export const audienceRecordService = {
  getAllHearingTypeByCustomerId: async ({ customerId, active }: any) => {
    try {
      const { data } = await api.get(
        routers_constants.audienceRecord.GetAllHearingTypeByCustomerId({
          customerId,
          active,
        }),
      );

      return {
        data: data.data,
        status: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        status: false,
      };
    }
  },
  createAudienceRecord: async ({
    hearingId,
    expectedDate,
    userId,
    hearingFileTypeId,
    attendantId,
    confidential,
  }: any) => {
    try {
      const { data } = await api.post(
        routers_constants.audienceRecord.createAudienceRecord,
        {
          hearingId: hearingId,
          type: 1,
          title: format(expectedDate, "dd/mm/yyyy"),
          recordId: "00000000-0000-0000-0000-000000000000",
          filename: "00000000-0000-0000-0000-000000000000",
          duration: 0,
          fileOrder: 0,
          expectedDate: expectedDate,
          download: false,
          upload: false,
          status: recordStatus.Agendado,
          userId: userId,
          hearingFileTypeId: hearingFileTypeId,
          confidential: confidential,
          attendantId: attendantId,
          watermark: 0,
          platform: 1,
          logUserId: userId,
          ...(hearingFileTypeId ? { hearingFileTypeId } : {}),
          ...(attendantId ? { attendantId } : {}),
          ...(confidential !== undefined ? { confidential } : {}),
        },
      );

      return {
        data: data.data,
        status: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        status: false,
      };
    }
  },
};
